import { render, staticRenderFns } from "./MediasLayout.vue?vue&type=template&id=f5f45494&scoped=true&lang=pug&"
import script from "./MediasLayout.vue?vue&type=script&lang=ts&"
export * from "./MediasLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f45494",
  null
  
)

export default component.exports